export default __webpack_public_path__ + "static/media/scrum-alliance.d31ce5f0.svg";